import { authFetch, API_URL, clearAuthSession, getAuthHeaders } from "../../utils/auth";

const DASHBOARD_URL = `${API_URL}/admin/dashboard/`;

function headers() {
  return { Accept: "application/json", ...getAuthHeaders() };
}

async function parse(response) {
  const contentType = response.headers.get("content-type") || "";
  const data = contentType.includes("application/json") ? await response.json() : { detail: "The request could not be completed." };
  if (response.status === 401) clearAuthSession();
  if (!response.ok) {
    const error = new Error("Dashboard data could not be loaded. Please try again.");
    error.status = response.status;
    error.data = data;
    throw error;
  }
  return data;
}

export async function fetchAdminDashboard({ period = "week", signal } = {}) {
  const params = new URLSearchParams();
  if (period) params.set("period", period);
  return parse(await authFetch(`${DASHBOARD_URL}?${params}`, { headers: headers(), signal }));
}
